import CustomButton from "../../../../shared/ui/CustomButton";
import React from "react";

const ReportMenu = ({scrollToIndex, table6, table7, table9} : {scrollToIndex: (i: number) => void, table6: any[], table7: any[], table9: any[]}) => {
    return (
        <>
            <h2 className='mb-6'>Cuprins</h2>
            <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                <CustomButton
                    size="large"
                    buttonType="text"
                    bgcolor="text"
                    onClick={() => scrollToIndex(0)}
                    sxExtra={{marginBottom: "10px"}}>
                    SECȚIUNEA 1: Surse ale datelor / participarea la testare
                </CustomButton>
                <CustomButton
                    size="large"
                    buttonType="text"
                    bgcolor="text"
                    onClick={() => scrollToIndex(1)}
                    sxExtra={{marginBottom: "10px"}}>
                    SECȚIUNEA 2: Privire de ansamblu asupra rezultatelor
                </CustomButton>
                <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start", paddingLeft: "20px"}}>
                    <CustomButton
                        size="large"
                        buttonType="text"
                        bgcolor="text"
                        onClick={() => scrollToIndex(2)}
                        sxExtra={{marginBottom: "10px"}}>
                        2.1. Scoruri medii și distribuții în interiorul școlii
                    </CustomButton>
                    <CustomButton
                        size="large"
                        buttonType="text"
                        bgcolor="text"
                        onClick={() => scrollToIndex(3)}
                        sxExtra={{marginBottom: "10px"}}>
                        2.2. Distribuția elevilor în categorii decile naționale
                    </CustomButton>
                    <CustomButton
                        size="large"
                        buttonType="text"
                        bgcolor="text"
                        onClick={() => scrollToIndex(4)}
                        sxExtra={{marginBottom: "10px"}}>
                        2.3. Distribuția elevilor în categorii de risc
                    </CustomButton>
                </div>
                <CustomButton
                    size="large"
                    buttonType="text"
                    bgcolor="text"
                    onClick={() => scrollToIndex(5)}
                    sxExtra={{marginBottom: "10px"}}>
                    SECȚIUNEA 3. Rezultate privind competențele măsurate, pentru fiecare clasă
                </CustomButton>
                <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start", paddingLeft: "20px"}}>
                    <CustomButton
                        size="large"
                        buttonType="text"
                        bgcolor="text" onClick={() => scrollToIndex(6)}
                        sxExtra={{marginBottom: "10px"}}>
                        3.1. Scoruri medii și distribuții pentru fiecare clasa
                    </CustomButton>
                    <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start", paddingLeft: "20px"}}>
                        {table6.map((t6: any, index: number) => (
                            <CustomButton
                                key={index}
                                size="large"
                                buttonType="text"
                                bgcolor="text"
                                onClick={() => scrollToIndex((7 + index))}
                                sxExtra={{marginBottom: "10px"}}>
                                3.1.{index + 1}. Scoruri medii pentru clasa {table6[index][0].grade}
                            </CustomButton>
                        ))}
                    </div>
                    <CustomButton
                        size="large"
                        buttonType="text"
                        bgcolor="text"
                        onClick={() => scrollToIndex((7 + table6.length))}
                        sxExtra={{marginBottom: "10px"}}>
                        3.2. Distribuția elevilor în categorii decile naționale pentru fiecare clasa
                    </CustomButton>
                    <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start", paddingLeft: "20px"}}>
                        {table7.map((t7: any, index: number) => (
                            <CustomButton
                                key={index}
                                size="large"
                                buttonType="text"
                                bgcolor="text"
                                onClick={() => scrollToIndex((7 + table7.length + index + 1))}
                                sxExtra={{marginBottom: "10px"}}>
                                3.2.{index + 1}. Distribuția elevilor în categorii decile naționale pentru clasa {table7[index][0].grade}
                            </CustomButton>
                        ))}
                    </div>
                    <CustomButton
                        size="large"
                        buttonType="text"
                        bgcolor="text"
                        onClick={() => scrollToIndex((7 + table6.length + table7.length + 1))}
                        sxExtra={{marginBottom: "10px"}}>
                        3.3. Distribuția elevilor în categorii de risc pentru fiecare clasa
                    </CustomButton>
                    <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start", paddingLeft: "20px"}}>
                        {table9.map((t9: any, index: number) => (
                            <CustomButton
                                key={index}
                                size="large"
                                buttonType="text"
                                bgcolor="text"
                                onClick={() => scrollToIndex((7 + table6.length + table9.length + index + 2))}
                                sxExtra={{marginBottom: "10px"}}>
                                3.3.{index + 1}. Distribuția elevilor în categorii de risc pentru clasa {table9[index][0].grade}
                            </CustomButton>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReportMenu;